import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import PlaceOrder from "../placeOrder/index";
import ConfirmCancel from "../placeOrder/confirmCancel";
import Button from "../../components/button";
import Indoor from "../Delivery/indoor";
import Outdoor from "../Delivery/outdoor";
import { EMenuActions } from "../../store";
import axios from "axios";
import { CompanyActions } from "../../store/company_dtl";
import { PaystackButton } from "react-paystack";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";

export default function Index() {
  let dispatch = useDispatch();
  let navigate = useNavigate();

  const publicKey = useSelector((state) => state.Company.paystack_pk);
  const cartItems = useSelector((state) => state.EMenu.cartItems);
  const deliveryMethod = useSelector((state) => state.EMenu.deliveryMethod);
  const placeOrder = useSelector((state) => state.EMenu.placeOrder);
  const confirmCancel = useSelector((state) => state.EMenu.confirmCancel);
  const userName = useSelector((state) => state.User.userName);
  const email = useSelector((state) => state.User.userEmail);
  const userPhone = useSelector((state) => state.User.userPhone);
  const userAddress = useSelector((state) => state.User.userAddress);
  const userCity = useSelector((state) => state.User.userCity);
  const userState = useSelector((state) => state.User.userState);
  const userCountry = useSelector((state) => state.User.userCountry);
  const c_url = useSelector((state) => state.Company.c_url);
  const auth_token = useSelector((state) => state.Company.auth_token);
  const selected_table = useSelector((state) => state.Company.selected_table);
  const selected_tableId = useSelector(
    (state) => state.Company.selected_tableId
  );
  const m_id = useSelector((state) => state.Company.m_id);
  const SalesPoint = useSelector((state) => state.Company.SalesPoint);
  const BranchId = useSelector((state) => state.Company.BranchId);
  const indoor_selected_value = useSelector(
    (state) => state.EMenu.indoor_selected_value
  );
  const delivery = useSelector((state) => state.User.delivery);
  const ShippingCost = delivery;
  const ShippingLocationId = delivery;
  const orderId = useSelector((state) => state.EMenu.emenuOrderId);
  const localOrderId = localStorage.getItem("orderId");
  const table = useSelector((state) => state.Company.tableNo);
  const total = useSelector((state) => state.EMenu.TotalPrice);
  const vatRate = useSelector((state) => state.Tax.vatRate);
  const serviceRate = useSelector((state) => state.Tax.serviceRate);
  const stateRate = useSelector((state) => state.Tax.stateRate);
  const sumOfTax = useSelector((state) => state.Tax.sumOfTax);
  const chargeType = useSelector((state) => state.Tax.chargeType);
  const hideTax = useSelector((state) => state.Tax.hideTax);
  const inclusiveTotal = useSelector((state) => state.Tax.incTotal);
  const exclusiveTotal = useSelector((state) => state.Tax.exclTotal);
  const price = chargeType === "1" ? total : exclusiveTotal;
  const sellTotalPrice = cartItems.reduce(
    (sum, item) => sum + Number(Number(item.sellPrice) * Number(item.Quantity)),
    0
  );
  const posLicense = useSelector((state) => state.Company.POSLic);
  const available_table = useSelector((state) => state.Company.available_table);
  const tableid = useSelector((state) => state.Company.tableId);
  const waiterScreen = useLocation().pathname.split("/")[2];
  console.log(waiterScreen)
  const [loading, setLoading] = useState(false);

  const amount = Number(price) + Number(delivery);
  const userObject = JSON.parse(localStorage.getItem("waiterId") || "[]");
  const userId = userObject[0]?.UserId;
  // console.log(userId)

  // console.log("tll", table);
  const componentProps = {
    email: email,
    amount: amount * 100,
    metadata: {
      userName,
      userPhone,
    },
    publicKey,
    cartItems,
    text: "Pay Now & Place Order",
    onSuccess: () =>
      setTimeout(
        () => dispatch(EMenuActions.setPlaceOrder(false)),
        handlePlaceOrder(),
        // console.log(handlePlaceOrder),
        localStorage.removeItem("cartItems"),
        dispatch(EMenuActions.setCartItems([])),
        dispatch(CompanyActions.setSL_TB("undefined")),
        dispatch(EMenuActions.setViewOrder(false)),
        dispatch(EMenuActions.setShowSection(false)),
        dispatch(EMenuActions.setFavouritePage(false)),
        dispatch(EMenuActions.setLoadProducts(false)),
        dispatch(EMenuActions.setActiveGroup(null)),
        navigateToHome(),

        alert("Thanks for doing business with us! Come back soon!!"),
        1000
      ),
    onClose: () => alert("Wait! Don't leave"),
  };
  const Price = Number(amount).toLocaleString("en-NG", {
    style: "currency",
    currency: "NGN",
  });

  function todayDate() {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    const yyyy = today.getFullYear();
    return yyyy + "-" + mm + "-" + dd;
  }

  const Req_Data = {
    orderInfo: [
      {
        TableNo: table || selected_table || 0,
        TotalAmount: amount,
        SalesPoint,
        BranchId,
        payment: `${
          indoor_selected_value === "unpaid" ? "0" : "is_paystack_enabled"
        }`,
        ShippingCost,
        ShippingLocationId,
        deliveryMethod,
        OrderNote: "",
        WaiterId: userId ? userId : 0
      },
    ],
    orderItems: [...cartItems],
    customerInfo: [
      {
        id: "",
        Name: userName,
        EmailAddress: email,
        BillingName: userName,
        BillingPhone: userPhone,
        BillingAddress: userAddress,
        BillingCity: userCity,
        BillingState: userState,
        BillingCountry: userCountry,
        BillingZip: "54321",
        ShippingAddress: "789 Shipping Road",
        ShippingCity: "Shippingtown",
        ShippingPhone: "123-456-7890",
        ShippingState: "Shipping State",
        ShippingCountry: "Shipping Country",
        ShippingZip: "12345",
        deleted: 0,
      },
    ],
  };

  const navigateToHome = () => {
    if (available_table && waiterScreen === "menu") {
      navigate(`/${m_id}/menu`);
    } else if (waiterScreen === "waiterscreen") {
      navigate(`/${m_id}/waiterscreen`);
    } else if (waiterScreen === "tablemenu") {
      navigate(`/${tableid}/tablemenu`);
    }
  };
  // console.log(JSON.stringify(Req_Data));

  const handlePlaceOrder = async () => {
    setLoading(true);
    if (Number(posLicense) === 2) {
      if (email && (table || selected_table)) {
        const submitOrder = await axios.post(
          `https://${c_url}/api/v1/Order`,
          Req_Data,
          {
            headers: {
              Authorization: `${auth_token}`,
            },
          }
        );
        if (submitOrder.status === 200 || submitOrder.status === 201) {
          setLoading(false);
          toast.success("Order placed successfully 👍", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setTimeout(() => {
            dispatch(EMenuActions.setPlaceOrder(false));
            localStorage.removeItem("cartItems");
            dispatch(EMenuActions.setCartItems([]));
            dispatch(CompanyActions.setSL_TB(""));
            dispatch(EMenuActions.setViewOrder(false));
            dispatch(EMenuActions.setShowSection(false));
            dispatch(EMenuActions.setFavouritePage(false));
            dispatch(EMenuActions.setLoadProducts(false));
            dispatch(EMenuActions.setActiveGroup(null));
            navigateToHome();
            dispatch(EMenuActions.setAcceptAwaiting(true));
            dispatch(EMenuActions.setEmenuOrderId(""));
            dispatch(EMenuActions.setAcceptStatus(""));
            dispatch(EMenuActions.setHoldApproval([]));
            dispatch(EMenuActions.clearApprovedOrder());
          }, 3000);
        }
      } else if (waiterScreen === "waiterscreen") {
        const submitOrder = await axios.post(
          `https://${c_url}/api/v1/Order`,
          Req_Data,
          {
            headers: {
              Authorization: `${auth_token}`,
            },
          }
        );
        if (submitOrder.status === 200 || submitOrder.status === 201) {
          setLoading(false);
          toast.success("Order placed successfully 👍", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setTimeout(() => {
            dispatch(EMenuActions.setPlaceOrder(false));
            localStorage.removeItem("cartItems");
            dispatch(EMenuActions.setCartItems([]));
            dispatch(CompanyActions.setSL_TB(""));
            navigateToHome();
            dispatch(EMenuActions.setAcceptAwaiting(true));
            dispatch(EMenuActions.setEmenuOrderId(""));
            dispatch(EMenuActions.setAcceptStatus(""));
            dispatch(EMenuActions.setHoldApproval([]));
            dispatch(EMenuActions.clearApprovedOrder());
          }, 3000);
        }
      } else {
        alert("need a valid email");
      }
    } else {
      alert("Please update your license to use this module");
    }
  };

  return (
    <div className=" md:px-7">
      <p className="font-black text-xl uppercase text-dark/60">
        Payment Details
      </p>
      <div>
        {deliveryMethod === "outdoor" ? (
          <Outdoor />
        ) : deliveryMethod === "indoor" ? (
          <Indoor />
        ) : null}
      </div>
      <div className="flex justify-between mb-4">
        <p>Total Number of Items in Cart</p>
        <p className="font-bold">{cartItems.length}</p>
      </div>
      <div
        className={`${hideTax === "1" && chargeType === "2" ? "" : "hidden"}`}
      >
        <div
          className={`${
            hideTax === "1" ? "flex justify-between mb-2" : "hidden"
          }`}
        >
          <p className="font-extrabold text-dark">Sub Total: </p>
          <p className="font-extrabold">
            {sellTotalPrice.toLocaleString("en-NG", {
              style: "currency",
              currency: "NGN",
            })}
          </p>
        </div>
        <div
          className={`${
            hideTax === "1" && chargeType === "2"
              ? "flex justify-between mb-2"
              : "hidden"
          }`}
        >
          <p className="font-extrabold text-dark">Total tax </p>
          <p className="font-extrabold">
            {(sellTotalPrice * sumOfTax).toLocaleString("en-NG", {
              style: "currency",
              currency: "NGN",
            })}
          </p>
        </div>
      </div>
      <div className="flex justify-between pt-2 mb-4">
        <p className="font-extrabold text-dark">Grand Total: </p>
        <p className="font-extrabold text-md">{Price}</p>
      </div>

      <div className="flex flex-col justify-between mt-10">
        {deliveryMethod === "outdoor" && (
          <>
            <PaystackButton
              className="bg-secondary text-white mb-4 p-3 w-[100%] text-sm rounded uppercase flex justify-center"
              {...componentProps}
            />
          </>
        )}{" "}
        {deliveryMethod === "indoor" && indoor_selected_value && (
          <div>
            {indoor_selected_value === "unpaid" ? (
              <div className="w-[100%] flex flex-col justify-between items-center gap-1">
                <Button
                  title={
                    loading ? "Placing order, please wait..." : "Place Order"
                  }
                  type={"bgBtn"}
                  bgColor={`bg-dark`}
                  textColor={"text-white"}
                  onClick={handlePlaceOrder}
                  disabled={loading ? true : false}
                />
              </div>
            ) : (
              <PaystackButton
                className="bg-secondary text-white font-bold p-3 w-[100%] text-sm rounded uppercase flex justify-center"
                {...componentProps}
              />
            )}
          </div>
        )}
      </div>
      {placeOrder && <PlaceOrder />}
      {confirmCancel && <ConfirmCancel />}
      <ToastContainer />
    </div>
  );
}
